import fetchClient from '@/lib/fetch'

export async function acceptTermsMutation(): Promise<any> {
  return fetchClient('/v1/auth/acceptCGU', {
    method: 'PATCH',
  })
}
